<template>
    <div class="price_field items-center" v-bind:class="{zero_price: isZero, changed_price : isChanged}" @click="start_edit">
        <div v-if="!edited" class="items-center">{{getPrice}}</div>
            <q-input  v-if="edited"
                v-model="price" 
                color='white'
                inverted-light
                hide-underline
                type="number"
                suffix="RUB" 
                max-width='25'
                @blur="doneEdit"
                @keyup.enter="doneEdit"
                @keyup.esc="cancelEdit"
                autofocus
                class="price-input"/>

    </div>
</template>




<script>
/* eslint-disable */
export default {
    props:{
            postId : {
                type: Number,
                requered: true,
            },
    },

    data () {
        return { 
            edited : false, // флаг режима редактирования
            price : 0,
            cachPrice : 0,
        }
    },


    computed : {
        
        isZero() {
            return this.price==0;
        },

        isChanged() {

            if (this.price == 0) return false; // если цена нулевая - то в любом случае она должна быть красной !!
            var item = this.$store.getters.getPostPrice(this.postId);
            if (item==undefined) return false;
            if (item.changed == undefined) return false;
            return item.changed;

        },

        getPrice() {
            
            this.price = 0*1;
            var item = this.$store.getters.getPostPrice(this.postId);
            if (item == undefined) return 0;
            this.price = item.cost*1;
            return item.cost;

        }

    },

    methods : {
        doneEdit() {
            var data = {
                post_type : this.postId,
                cost : this.price,
            }
            this.$store.commit("temporarilySavePostPrice", data);
            this.edited = false;
        },

        cancelEdit() {
            this.edited = false;
            this.price = this.cachPrice;
        },
        start_edit() {
            this.edited = true;
            this.cachPrice = this.price;
        }
    }

}
</script>

<style lang="scss" scoped>
    .price_field {
        width : 100%;
        text-align:left;
        // border: 1px solid black;
        margin: 0px;
        padding-left:35px;
        cursor:text;
        font-weight: bold;
    }
    .price-input{
        width : 80px;
        min-width:80px;
        margin-top:-20px;
        padding-top: 4px;
        font-size: 15px;
    }
    .zero_price {
        color : red;
        font-weight: bold;
    }
    .changed_price {
        color : green;
        font-weight: bold;
    }

</style>

